// extracted by mini-css-extract-plugin
export default {"modal":"InvitationModal_modal__JDmWl","row":"InvitationModal_row__4-W91"};